// extracted by mini-css-extract-plugin
export default {"newsfeedCard":"i5-z"};